<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <!-- <div v-if="mfaStatus == false" class="notification is-light is-danger">
      <p>
        {{ $t("auth.mfaWarning") }}
      </p>
      <router-link
        :to="{ name: 'profileStartMfa' }"
        class="button is-danger mt-2"
      >
        {{ $t("auth.startMfa") }}
      </router-link>
    </div> -->
    <Version />
    <Announce />
    <h5 class="title is-5">{{ $t("events.latestEvents") }}</h5>
    <EventsList
      :limit="5"
      :tenant-id="tenantId"
      :project-id="projectId"
    ></EventsList>
    <hr />
    <h5 class="title is-5">{{ $t("reports.report") }}</h5>
    <HourlyReports
      :tenant-id="tenantId"
      :project-id="projectId"
    ></HourlyReports>
  </div>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb";
import EventsList from "@/components/events/eventsListD.vue";
import HourlyReports from "@/components/reports/hourlyReportsD.vue";
import { computed, ref } from "vue";
// import { computed, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
// import { ImsrUsers } from "@/lib/imsrUsers.js";
import Version from "@/components/version/version.vue";
import Announce from "@/components/announce/announce.vue";

export default {
  components: {
    EventsList,
    Breadcrumb,
    HourlyReports,
    Version,
    Announce
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const breadcrumb = ref([{ title: "Home", path: "/", isActive: true }]);
    // 将来的に開放される機能のため、コメントアウトしておく
    // const mfaStatus = ref(null);
    // const imsrUsers = new ImsrUsers();

    // const fetchMfa = async () => {
    //   try {
    //     const checkMfa = await imsrUsers.checkMfa(store.getters.tenantId);
    //     mfaStatus.value = checkMfa.mfa;
    //   } catch (err) {
    //     mfaStatus.value = null;
    //   }
    // };

    // onMounted(fetchMfa);

    return {
      tenantId: computed(() => store.getters.tenantId),
      projectId: computed(() => route.params.projectId),
      breadcrumb
      // mfaStatus,
    };
  }
};
</script>
